import useMenuItems from "@/hooks/tiles/useMenuItems";
import { createContext } from "react"

export interface IMenuItemContext extends ReturnType<typeof useMenuItems> {
}

export const MenuItemContext = createContext<IMenuItemContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default MenuItemContext;